
import { v4 as uuid } from 'uuid'
import { SIZE_SMALL, SIZE_XLARGE } from '../../utils/constants'
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: SIZE_SMALL,
      validator: (x) => [SIZE_SMALL, SIZE_XLARGE].includes(x),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    labelClass: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      id: 'form-switch-' + uuid(),
      hasFocus: false,
    }
  },
  computed: {
    dotClass() {
      const cls = [
        'tw-pointer-events-none',
        'tw-inline-block',
        'tw-transform',
        'tw-rounded-full',
        'tw-bg-white',
        'tw-shadow',
        'tw-ring-0',
        'tw-transition',
        'tw-duration-150',
        'tw-ease-in-out',
      ]

      if (this.size === SIZE_SMALL) {
        cls.push('tw-w-3 tw-h-3')
        if (this.value) {
          cls.push('tw-translate-x-2')
        }
      } else {
        cls.push('tw-w-7 tw-h-7')
        if (this.value) {
          cls.push('tw-translate-x-4')
        }
      }

      if (!this.value) {
        cls.push('tw-translate-x-0')
      }

      return cls
    },
    toggleClass() {
      const cls = [
        'tw-relative',
        'tw-inline-flex',
        'tw-flex-shrink-0',
        'tw-border-2',
        'tw-border-transparent',
        'tw-rounded-full',
        'tw-transiton-colors',
        'tw-ease-in-out',
        'tw-duration-150',
        'focus:tw-outline-none',
        'focus:tw-ring-2',
        'focus:tw-ring-offset-2',
      ]

      if (this.disabled) {
        cls.push('tw-bg-gray-50')
      } else if (this.value) {
        cls.push('tw-bg-gray-800')
      } else {
        cls.push('tw-bg-gray-300')
      }

      if (this.size === SIZE_SMALL) {
        cls.push('tw-h-4 tw-w-6')
      } else {
        cls.push('tw-w-12 tw-h-8')
      }

      return cls
    },
    labelTextClass() {
      const cls = [this.labelClass]
      if (this.disabled) {
        cls.push('tw-text-gray-300')
      } else {
        cls.push('tw-text-gray-800')
      }
      return cls
    },
    hintTextClass() {
      const cls = ['tw-mb-0 tw-text-sm']
      if (this.disabled) {
        cls.push('tw-text-gray-300')
      } else {
        cls.push('tw-text-gray-500')
      }
      return cls
    },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return
      }

      this.$emit('change', !this.value)
      this.$emit('input', !this.value)
    },
  },
}
